


















































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapState } from "vuex";
import Project from "@/models/project/project";
// @ts-ignore
import { MoreVerticalIcon } from "vue-feather-icons";

@Component({
  components: {
    MoreVerticalIcon,
  },
  computed: {
    ...mapState("projects", ["projects"]),
  },
})
export default class ProjectsOverview extends Vue {
  projects!: Array<Project>;
  hideCompleted = false;

  get completedProjectsText(): string {
    return `Hide completed (${
      this.projects.filter((p) => p.isCompleted).length
    })`;
  }

  get filteredProjects(): Array<Project> {
    if (this.hideCompleted) {
      return this.projects.filter((p) => !p.isCompleted);
    }

    return this.projects;
  }
}
